import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PageStateService {
  private pageState: { [key: string]: number } = {};

  setPageState(key: string, page: number): void {
    this.pageState = {};
    this.pageState[key] = page;
  }

  getPageState(key: string): number | undefined {
    const page = this.pageState[key];
    this.pageState = {};

    return page;
  }

  clearPageState(key: string): void {
    delete this.pageState[key];
  }
}
